import { useCallback, useEffect, useState } from 'react';

/**
 * ノード入力欄のローカル状態管理。
 * committed を表示しつつ入力中はローカルで保持し、blur 時に onCommit で確定する。
 */
export function useNodeFieldState(
  committed: string,
  onCommit: (raw: string) => string | void
) {
  const [value, setValue] = useState(committed);

  useEffect(() => {
    setValue(committed);
  }, [committed]);

  const commit = useCallback(() => {
    const normalized = onCommit(value);
    if (typeof normalized === 'string') {
      setValue(normalized);
    }
  }, [onCommit, value]);

  return { value, setValue, commit };
}

